export function highlight(string, query) {
    if (!query) return string;
    const index = string.toLowerCase().indexOf(query.toLowerCase());
    if (index >= 0) {
        return (
            string.substring(0, index) +
            "<span class='highlight'>" +
            string.substring(index, index + query.length) +
            "</span>" +
            string.substring(index + query.length)
        );
    }
    return string;
}
